import styled from 'styled-components';
import { Search as SearchIcon } from '@mui/icons-material';
import MaterialInput from 'src/components/form/MaterialInput';

export const StyledSearchIcon = styled(SearchIcon)`
  color: ${({ theme }) => theme.colors.prussianBlue};
`;

export const Input = styled(MaterialInput)`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    outline: none;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-bottom: none;
  }
  & .MuiOutlinedInput-root:hover fieldset {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-bottom: none;
  }
  & .MuiOutlinedInput-notchedOutline {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-bottom: none;
  }

  & .MuiInputBase-root {
    padding-left: 12px;
  }

  & input,
  textarea {
    background: ${({ theme }) => theme.colors.white};
    padding-left: 10px;
  }
`;
